import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from 'src/app/app.constants';
import {CertificateRequestDto} from 'src/app/shared/model/certificate-trade-details.model';
import {VesselUnknownDTO} from 'src/app/shared/model/one-time-scope-change-t-and-c.model';
import {createRequestOption} from 'src/app/shared/util/request-util';
import {AdditionalPremiumRatePostData} from '../loss-payee-my-suffix/additionalPremiumRatePostData';

type EntityResponseType = HttpResponse<CertificateRequestDto>;
type EntityArrayResponseType = HttpResponse<CertificateRequestDto[]>;
@Injectable({ providedIn: 'root' })
export class BulkDeclarationService {

    constructor(private http: HttpClient) { }

    private downloadAllClausesUrl = SERVER_API_URL + 'api/bulk-download-certificate-clause'; 
    private downloadAllExtensionUrl = SERVER_API_URL + 'api/bulk-download-certificate-extension';
    private resourceUrl = SERVER_API_URL + 'api/bulk-certificate-requests';
    private _vesselUnknownNameImo: string = SERVER_API_URL + "api/add-vessel-name-or-imo-to-bulk-request";
    private _additionalPremiumRate: string = SERVER_API_URL + 'api/bulk-certificate-rule';


    create(certificateDto: CertificateRequestDto) {
        return this.http.post<any>(this.resourceUrl, certificateDto, { observe: 'response' });
    }

    update(certificateDto: CertificateRequestDto) {
        return this.http.put<any>(this.resourceUrl, certificateDto, { observe: 'response' });
    }

    find(id: number): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<any[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }


    scopeCreate(url, scope: any): Observable<any> {
        return this.http.post<any>(SERVER_API_URL + url, scope, { observe: 'response' }).map((res: any) => res);
    }

    queryWithId(url?: any, id?: number, req?: any): Observable<HttpResponse<any>> {
        const options = createRequestOption(req);
        return this.http
            .get(`${this.resourceUrl + url}/${id}`, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }


    queryWithUrl(url?: any, req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = this.resourceUrl + url;
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }

    private convertDateArrayFromServer(res: any): any {
        return res.body;
    }

    queryWithFullURL(url?: any, req?: any): Observable<HttpResponse<any>> {
        const options = createRequestOption(req);
        return this.http
            .get(SERVER_API_URL + 'api' + url, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }
    getById(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http
            .get(SERVER_API_URL + url, { params: options, observe: 'response' })
            .map((res: any) => this.convertDateArrayFromServer(res));
    }

    postData(data: any, url: any): Observable<any> {
        return this.http.post<any>(url, data, { observe: 'response' });
    }

    getBy(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + 'api' + url, { observe: 'response' });
    }

    getClauseZip(data: any, url: any): Observable<HttpResponse<Blob>> {
        return this.http.put(this.downloadAllClausesUrl , data , {observe: 'response', responseType: 'blob'});
    }

    getExtensionZip(data: any, url: any): Observable<HttpResponse<Blob>> {
        return this.http.put(this.downloadAllExtensionUrl , data , {observe: 'response', responseType: 'blob'});
    }

    vesselNameImoUnknown(certificateRequestId: number, vesselUnknownDto: VesselUnknownDTO): Observable<any> {
        return this.http.post<any>(this._vesselUnknownNameImo+'/'+certificateRequestId, vesselUnknownDto, { observe: 'response' });
    }

    postAdditionalPremiumRate(data: AdditionalPremiumRatePostData, certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.post<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }

    putAdditionalPremiumRate(data: AdditionalPremiumRatePostData, certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.put<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }

    postAdditionalPremiumRateForBulk(data: AdditionalPremiumRatePostData, certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.post<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }

    putAdditionalPremiumRateForBulk(data: AdditionalPremiumRatePostData, certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.put<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }

}
